import React, {useMemo, useState} from 'react';
import {TaskListWrapper} from '../../../../my-work-tab/my-tasks-page/MyWork.styled';
import TaskRow from './Task_row';
import TaskListHeader from './Task_row_header';
import Util from '../../../util/util';
import {hasFeatureFlag} from '../../../util/FeatureUtil';

export const TaskList = ({
	intl,
	enabledColumns,
	tasks,
	history,
	viewer,
	enableSort,
	stickyTopPosition,
	isInContainer,
	localSortKey,
	cy,
	showNovaColumn: showNovaColumnOverride,
}) => {
	const [sortBy, setSortBy] = useState(
		localSortKey && Util.localStorageGetItem(localSortKey)
			? JSON.parse(Util.localStorageGetItem(localSortKey))
			: {column: null, ascending: false}
	);
	Util.sortTasks(tasks, sortBy);

	const setSorting = sortBy => {
		if (enableSort) {
			setSortBy(sortBy);
			if (localSortKey) {
				Util.localStorageSetItem(localSortKey, JSON.stringify(sortBy));
			}
		}
	};

	// Computed once here, not independently by the header and each row, so the two can never
	// disagree on whether the Nova column's width is reserved (a header/row width mismatch
	// misaligns every column after it).
	//
	// The override a caller may pass is no longer load-bearing: this used to vary with the tasks in
	// view, so sibling lists over one task set had to be told the answer or they would disagree and
	// misalign against each other. The column follows the feature alone now, so every list reaches
	// the same answer on its own. The prop is kept because its callers still pass it, and it can go
	// whenever they stop.
	const computedShowNovaColumn = useMemo(() => hasFeatureFlag('nova_agent_invocation'), []);
	const showNovaColumn = showNovaColumnOverride !== undefined ? showNovaColumnOverride : computedShowNovaColumn;

	return (
		<TaskListWrapper>
			<TaskListHeader
				intl={intl}
				enabledColumns={enabledColumns}
				sortBy={sortBy}
				onSortByChange={enableSort ? sortBy => setSorting(sortBy) : null}
				stickyTopPosition={stickyTopPosition}
				isInContainer={isInContainer}
				showNovaColumn={showNovaColumn}
			/>
			{tasks.map(task => (
				<TaskRow
					cy={cy}
					key={task.node.id}
					intl={intl}
					task={task.node}
					enabledColumns={enabledColumns}
					showTaskModal={taskId => Util.showTaskModal(taskId, history)}
					viewer={viewer} //TODO to removed, only used for Generic task context menu
					showNovaColumn={showNovaColumn}
				/>
			))}
		</TaskListWrapper>
	);
};
